module.exports = __webpack_public_path__ + "img/munzinger-laender.c434a260.png";